enum PlanSubscriptionSetupMode {
    DISABLED = 'disabled',
    INTERNAL = 'internal',
    PUBLIC = 'public',
}

export default PlanSubscriptionSetupMode;
